import { EarningsRange } from "@pax/api-contract/accounting/v1alpha1";
import { PresetId } from "@pax/api-contract/common";
import { createFileRoute } from "@tanstack/react-router";
import { EarningsScreen, type EarningsSearch } from "@/features/earnings/EarningsScreen";
import { periodsBackFrom } from "@/features/ledger/charts/PeriodStepper";

export const Route = createFileRoute("/_authenticated/earnings")({
  validateSearch: (search: Record<string, unknown>): EarningsSearch => ({
    presetId: PresetId.safeParse(search.presetId).data,
    range: EarningsRange.safeParse(search.range).data,
    back: periodsBackFrom(search.back),
  }),
  staticData: { access: "account" },
  head: () => ({ meta: [{ title: "Preset earnings · Pax.co" }] }),
  component: EarningsPage,
});

function EarningsPage() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <EarningsScreen
      search={search}
      onSearchChange={(next, replace) =>
        void navigate({ search: next, replace, resetScroll: false })
      }
    />
  );
}
